import React, { ReactNode } from 'react';
import Button from '../../button/v2/button';
import { VStack } from '../../layouts/stack.layout';
import Container from '../container';

type Props = {
  title: string;
  action?: Function;
  children: ReactNode;
  gap?: 'xs' | 'sm' | 'base' | 'md' | 'lg' | 'xl';
};

const styles = {
  text: 'font-text text-lg font-medium text-primary capitalize',
};

export default function DiscoverSection({
  title,
  children,
  action,
  gap,
}: Props) {
  return (
    <VStack
      gap={gap || 'base'}
      extensions="w-full mobile:px-2 tablet-lg:px-[40px]"
    >
      <Container extensions={styles.text}>{title}</Container>
      <Container extensions="w-full">{children}</Container>
      {action && (
        <Button variant="text" color="glass" onClick={action}>
          View More
        </Button>
      )}
    </VStack>
  );
}
